module.exports = __webpack_public_path__ + "img/J1L_Halloween.afb69018.svg";